import React from 'react';

import { object, string } from 'prop-types';

import classes from './TotalsPanel.module.css';

const TotalsPanel = ({
    data,
    entityType,
    filteredRules,
    ...props
}) => {

    if (entityType === 'Announcements') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Release Notes</p>
                        <p className={classes.Value}>{data.totalRecordCount || '0'}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'Contacts') {
        return null;
    }

    if (entityType === 'Reporting') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Reports</p>
                        <p className={classes.Value}>{data.totalRecordCount || '0'}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'BackgroundJobs') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Complete</p>
                        <p className={classes.Value}>{data.complete || '0'}</p>
                    </div>
                </div>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>In Process</p>
                        <p className={classes.Value}>{data.inProgress || '0'}</p>
                    </div>
                </div>
                {/* <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Failed</p>
                        <p className={classes.Value}>
                            {data.failed || '0'}
                        </p>
                    </div>
                </div> */}
            </div>
        );
    }

    if (entityType === 'ServiceManagement') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Requests</p>
                        <p className={classes.Value}>{data.totalRecordCount || '0'}</p>
                    </div>
                </div>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>New</p>
                        <p className={classes.Value}>{data.totalFaultCount || '0'}</p>
                    </div>
                    <div>
                        <p className={classes.Title}>Approved</p>
                        <p className={classes.Value}>
                            {data.totalHighFaultCount || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Canceled</p>
                        <p className={classes.Value}>
                            {data.totalMediumFaultCount || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'Roles') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Users</p>
                        <p className={classes.Value}>{data.totalRecordCount || '0'}</p>
                    </div>
                </div>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>locked</p>
                        <p className={classes.Value}>{data.totalFaultCount || '0'}</p>
                    </div>
                    <div>
                        <p className={classes.Title}>Disabled</p>
                        <p className={classes.Value}>
                            {data.totalHighFaultCount || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if ( entityType === 'CompanyManagement') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Companies</p>
                        <p className={classes.Value}>{data.totalCount || '0'}</p>
                    </div>
                </div>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Active</p>
                        <p className={classes.Value}>{data.totalActive || '0'}</p>
                    </div>
                    <div>
                        <p className={classes.Title}>Inactive</p>
                        <p className={classes.Value}>
                            {data.totalInactive || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'Users') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Users</p>
                        <p className={classes.Value}>{data.totalFaultCount || '0'}</p>
                    </div>
                    <div>
                        <p className={classes.Title}>Locked</p>
                        <p className={classes.Value}>
                            {data.totalHighFaultCount || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Disabled</p>
                        <p className={classes.Value}>
                            {data.totalMediumFaultCount || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'SiteScore') {
        return (
            <div className={classes.SiteTotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>Rules</p>
                        <p className={classes.Value}>{data.length || '0'}</p>
                    </div>
                </div>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Fault Occurrences</p>
                        <p className={classes.Value}>-</p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'Health Monitors') {
        return (
            <div className={classes.TotalsPanel}>
                <div className={classes.EntityContainer}>
                    <div>
                        <p className={classes.Title}>{'Fault'}</p>
                        <p className={classes.Value}>{(data.low + data.medium + data.high) || '0'}</p>
                    </div>
                </div>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>High</p>
                        <p className={classes.Value}>
                            <img className={classes.IconImage} src={'/assets/images/high.svg'} alt="" />
                            {data.high || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Medium</p>
                        <p className={classes.Value}>
                            <img className={classes.IconImage} src={'/assets/images/medium.svg'} alt="" />
                            {data.medium || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Low</p>
                        <p className={classes.Value}>
                            <img className={classes.IconImage} src={'/assets/images/low.svg'} alt="" />
                            {data.low || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (entityType === 'RuleList') {
        return (
            <div className={classes.BobRulesPageTotalsPanel}>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Enabled Rules</p>
                        <p className={classes.Value}>
                            {data.totalCount || '0'}
                        </p>
                    </div>
                    { filteredRules ? 
                        <>
                            <div>
                                <p className={classes.Title}>Active Faults</p>
                                <p className={classes.Value}>
                                    {data.activeFaults || '0'}
                                </p>
                            </div>
                            <div>
                                <p className={classes.Title}>Rule failure</p>
                                <p className={classes.Value}>
                                    {data.failureCounts || '0'}
                                </p>
                            </div>
                        </>
                        : null 
                    }
                </div>
            </div>
        );
    }

    if (entityType === 'Faults') {
        return (
            <div className={classes.BobRulesPageTotalsPanel}>
                <div className={classes.FaultsContainer}>
                    <div>
                        <p className={classes.Title}>Rule Count</p>
                        <p className={classes.Value}>
                            {data.totalRuleCount || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Active Faults</p>
                        <p className={classes.Value}>
                            {data.totalActiveFaults || '0'}
                        </p>
                    </div>
                    <div>
                        <p className={classes.Title}>Rule Failures</p>
                        <p className={classes.Value}>
                            {data.totalRuleFailures || '0'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.TotalsPanel}>
            <div className={classes.EntityContainer}>
                <div>
                    <p className={classes.Title}>{entityType}</p>
                    <p className={classes.Value}>{data.totalRecordCount || '0'}</p>
                </div>
            </div>
            <div className={classes.FaultsContainer}>
                <div>
                    <p className={classes.Title}>Current Period Faults</p>
                    <p className={classes.Value}>{data.totalFaultCount || '0'}</p>
                </div>
                <div>
                    <p className={classes.Title}>High</p>
                    <p className={classes.Value}>
                        <img className={classes.IconImage} src={'/assets/images/high.svg'} alt="" />
                        {data.totalHighFaultCount || '0'}
                    </p>
                </div>
                <div>
                    <p className={classes.Title}>Medium</p>
                    <p className={classes.Value}>
                        <img className={classes.IconImage} src={'/assets/images/medium.svg'} alt="" />
                        {data.totalMediumFaultCount || '0'}
                    </p>
                </div>
                <div>
                    <p className={classes.Title}>Low</p>
                    <p className={classes.Value}>
                        <img className={classes.IconImage} src={'/assets/images/low.svg'} alt="" />
                        {data.totalLowFaultCount || '0'}
                    </p>
                </div>
            </div>
        </div>
    );
};

TotalsPanel.defaultProps = {
    data:       {},
    entityType: ''
};

TotalsPanel.propTypes = {
    data:       object,
    entityType: string
};

export default TotalsPanel;
